// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import styles from './vs_toolip.module.less';
import {Products_cards} from '../free_proxy/product_cards';
import {HP_cards} from '../hp_cards';
import {Review_slides} from '../landings/review_slides';
import {Feature_cards} from './feature_cards';
import {Vs_hero} from './vs_hero';
import {Cta_section} from './cta_section';
import {Vs_faq} from './vs_faq';
import {Comparison_table} from './comparison_table';
import {HP_global} from '../../pages/toolip.io/free-proxy';

export type i_company_name = 'lunaproxy' | 'iproyal' | 'packetstream' |
    'dataimpulse' | 'webshare' | 'geonode' | 'bytio' | 'soax' | 'croxyproxy' |
    'froxy';

interface i_vstoolip_props {
    company: i_company_name;
}

export const company_display_names = {
    lunaproxy: 'Lunaproxy',
    iproyal: 'IPRoyal',
    packetstream: 'PacketStream',
    dataimpulse: 'DataImpulse',
    webshare: 'Webshare.io',
    geonode: 'Geonode',
    bytio: 'Bytio',
    soax: 'SOAX',
    croxyproxy: 'CroxyProxy',
    froxy: 'Froxy'
};

const vs_data = {
    lunaproxy: {
        hero_title: 'Toolip.io: The Most Reliable Alternative to LunaProxy',
        hero_subtitle: 'Get access to millions of premium residential proxies '
            +'with unparalleled reliability, advanced features, and flexible '
            +'pricing.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'lunaproxy.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'lunaproxy_full.svg',
        features: '1,2,5',
        start_price: '$0.77/GB'
    },
    iproyal: {
        hero_title: 'Toolip.io vs. IPRoyal: Elevate Your Proxy Experience',
        hero_subtitle: 'In the realm of proxy services, choosing the right '
            +'provider is crucial. Here`s why Toolip.io stands out as the '
            +'superior choice over IPRoyal.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'iproyal.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'iproyal_full.svg',
        features: '1, 2, 5',
        start_price: '$1.75/GB'
    },
    packetstream: {
        hero_title: 'Toolip.io: The Ultimate PacketStream Alternative',
        hero_subtitle: 'Selecting the best proxy service can make or break '
            +'your projects. Here`s why Toolip.io is the preferred choice for '
            +'professionals compared to PacketStream.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'packetstream.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'packetstream_full.svg',
        features: '1',
        start_price: '$1.00/GB'
    },
    dataimpulse: {
        hero_title: 'Toolip.io: A Smarter Choice Than DataImpulse',
        hero_subtitle: 'Looking for the best proxy service? Here`s why'
            +'Toolip.io is the top alternative to DataImpulse for businesses '
            +'and developers.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'dataimpulse.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'dataimpulse_full.svg',
        features: '1, 2',
        start_price: '$1.00/GB'
    },
    webshare: {
        hero_title: 'Toolip.io vs. Webshare: Choosing the Optimal Proxy '
            +'Service',
        hero_subtitle: 'Selecting the right proxy service is crucial for your '
            +'business`s success. Here`s why Toolip.io stands out compared to '
            +'Webshare.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'webshare.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'webshare_full.svg',
        features: '1, 2, 5',
        start_price: '$3.00/GB'
    },
    geonode: {
        hero_title: 'Toolip.io: The Best Alternative to Geonode',
        hero_subtitle: 'Unlock superior proxy solutions with Toolip.io, '
            +'featuring unparalleled reliability, cutting-edge features, and '
            +'cost-effective pricing.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'geonode.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'geonode_full.svg',
        features: '1, 5',
          start_price: '$0.97/GB'
    },
    bytio: {
        hero_title: 'Toolip.io: The Best Alternative to Bytio',
        hero_subtitle: 'Upgrade your proxy experience with Toolip.io—offering '
            +'faster connections, smarter features, and pricing that works '
            +'for you.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'bytio.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'bytio_full.svg',
        features: '1, 5',
        start_price: '$1.25/GB'
    },
    croxyproxy: {
        hero_title: 'Toolip.io vs. CroxyProxy: Reliable Proxies for Your '
            +'Business Needs',
        hero_subtitle: 'CroxyProxy positions itself as a free web proxy '
            +'service, but here`s why Toolip.io is the smarter alternative '
            +'for professional and enterprise proxy use cases.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'croxyproxy.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'croxyproxy_full.svg',
        features: '',
        start_price: 'Free (limited features)'
    },
    soax: {
        hero_title: 'Toolip.io vs. SOAX: Discover Superior Proxy Performance',
        hero_subtitle: 'In the competitive proxy landscape, selecting the '
            +'right service makes all the difference. Here`s why Toolip.io is '
            +'the better choice when compared to SOAX.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'soax.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'soax_full.svg',
        features: '1, 2, 5',
        start_price: '$4.00/GB'
    },
    froxy: {
        hero_title: 'Toolip.io vs. Froxy: Cutting-Edge Proxy Comparisons',
        hero_subtitle: 'Toolip.io vs. Froxy: Cutting-Edge Proxy Comparisons '
            +'Toolip.io has solidified its position as a leader in the proxy '
            +'market. Here`s why Froxy falls short compared to Toolip.io.',
        hero_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'froxy.svg',
        full_logo: 'https://cdn4.toolip.io/www/toolip/pub/img/competitors/'
            +'froxy_full.svg',
        features: '1, 2, 5',
        start_price: '$2.93/GB'
    }
};

const cta_data = [
    {
        title: 'Take the Next Step Toward Smarter Proxy Solutions',
        subtitle: company=>
            `Don't settle for less. Experience why Toolip.io outshines
            ${company}`,
        caption: 'Start Your Free Trial Now'

    },
    {
        title: 'Take Control of Your Proxy Needs with Toolip.io',
        subtitle: company=>
            `Don't settle for limited features. Experience why Toolip.io is
            the superior choice over ${company}.`,
        caption: 'Start Your Free Trial Now'
    }
];

export const Vs_toolip = (props: i_vstoolip_props)=>{
    const company_name = company_display_names[props.company];
    return <div>
      <Vs_hero
        company={props.company}
        hero_title={vs_data[props.company].hero_title}
        hero_subtitle={vs_data[props.company].hero_subtitle}
        hero_logo={vs_data[props.company].hero_logo}/>
      <Feature_cards/>
      <Comparison_table
        company={props.company}
        full_logo={vs_data[props.company].full_logo}
        features={vs_data[props.company].features}
        start_price={vs_data[props.company].start_price}
      />
      <Products_cards
        title={'The toolip Products'}
        subtitle=
          {'Choose what best matches your needs and goals on the house!'}/>
      <HP_cards version={'v2'}/>
      <Cta_section
        title={cta_data[0].title}
        subtitle={cta_data[0].subtitle(company_name)}
        caption={cta_data[0].caption}
      />
      <HP_global cls={styles.map}/>
      <Review_slides/>
      <Vs_faq company={props.company}/>
      <Cta_section
        title={cta_data[1].title}
        subtitle={cta_data[1].subtitle(company_name)}
        caption={cta_data[1].caption}
      />
    </div>;
};
